import React from 'react'
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import Question from './Question.js'
import './style.css'
import Results from './results.js'
import database from '../../database.js'
import {Loading} from '../generic.js';

let quizResultDB = 'ScreenQuizResults';

export default class QuizSection extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      score: 0,
      currentQ: -1,
      hasFinished: false,
      questions: null,
      counts: {}
    }
    this.onAnswer = this.onAnswer.bind(this)
  }

  componentWillMount () {
    database.collection('screen').orderBy("order", "asc").get().then(function (qs) {
      let newQuestions = [];
      let counts = {};
      console.log(qs);
      qs.docs.forEach(function (doc, i) {
        newQuestions[i] = {
          question: doc.data().question||"",
          type: doc.data().type,
          reverse: doc.data().reverse || false
        }
        if(!counts[doc.data().type]) {
          counts[doc.data().type] = 0;
        }
        counts[doc.data().type] ++;
      })
      this.setState({
        questions: newQuestions,
        counts: counts
      })
    }.bind(this))
      .catch(function (error) {
        console.log(error)
    })
  }

  endQuiz () {
    this.setState({
      hasFinished: true
    })
  }

  onAnswer (answer, currentOrder, type, history) {
    if (currentOrder !== -1) {
      storeResult(answer, currentOrder, type)
    } else {
      sessionStorage.removeItem(quizResultDB);
    }
    if (parseInt(currentOrder, 0) === this.state.questions.length - 1) {
      history.push('/*/quiz/feelings/results')
    } else {
      history.push('/*/quiz/feelings/' + (parseInt(currentOrder, 0) + 1))
    }
  }

  render () {
    if (this.state.questions) {
      console.log(this.props.location.pathname);
      return (
          <div className={this.props.location.pathname === ('/youth/quiz/feelings')?'screen-container-youth':'screen-container'}>
            <Router>
                <span>
                  <Switch>
                <Route path='/*/quiz/feelings/results' render={props => <Results counts={this.state.counts} {...props} />} />
                <div className='questions-container'>
                  <Route exact path='/*/quiz/feelings' render={({match, location, history}) => {
                    return (
                      <QuizIntro onAnswer={() => {
                        this.onAnswer(0, -1, 0, history)
                      }} />
                    )
                  }} />
                <Route path='/*/quiz/feelings/:order' render={({match, location, history}) => {
                  let currentResult = (JSON.parse(sessionStorage.getItem(quizResultDB)) || [])[match.params.order]
                  console.log(currentResult);
                  let currentValue = -1
                  if (currentResult) {
                    currentValue = currentResult.value
                  }
                  return (
                    <Question
                      currentAnswer={currentValue}
                      questionText={this.state.questions[match.params.order].question}
                      questionOrder={match.params.order}
                      reverseScore={this.state.questions[match.params.order].reverse}
                      onAnswer={(ans) => {
                        this.onAnswer(
                            ans,
                            match.params.order,
                            this.state.questions[match.params.order].type,
                            history)
                      }} />
                  )
                }} />
              </div>

              </Switch>
            </span>
            </Router>
          </div>

      )
    } else {
      return (<Loading />)
    }
  }
}

class QuizIntro extends React.Component {
  constructor (props) {
    super(props)
    this.props = props
    this.state = {
      confirmedAge: false,
      confirmedAgreed: false
    }
    this.toggleConfirmAge = this.toggleConfirmAge.bind(this)
  }

  toggleConfirmAge (v) {
    this.setState((state) => {
      state[v] = !state[v]
      return state
    })
  }

  render () {
    return (
      <span>
        <p className='intro'>
          <p><b>Me & My Feelings (M&MF)</b> is a brief school-based measure of child mental health. 
          It asks questions about emotional difficulties and behavioural difficulties.
          It was developed by the Anna Freud Centre.</p>
 
          <p>The questions help young people over the age of 8 years understand if difficulties 
            they are experiencing might be emotional and behavioural difficulties that they 
            should be concerned about. These questions are not aimed at diagnosing problems 
            they are to support young people in getting help if they need it.</p>
          <ul>
            <li>Young people over 8 years may wish to complete the quiz alone but should discuss their results with a teacher.</li>
            <li>Teachers completing the questions on behalf of a young person should follow their usual school consent procedures.</li>
          </ul>
          <div className='age-checkbox-wrapper'>
            <label><input type='checkbox' value='' onClick={this.toggleConfirmAge.bind(this, 'confirmedAge')} /> Are you 8 years plus?</label>
            <label><input type='checkbox' value='' onClick={this.toggleConfirmAge.bind(this, 'confirmedAgreed')} /> Has the young person agreed to answer these questions?</label>
          </div>
        </p>

        <button type='button' disabled={!this.state.confirmedAge || !this.state.confirmedAgreed} className={'next-question-button btn btn-block btn-success'} onClick={() => {
          if (this.state.confirmedAge && this.state.confirmedAgreed) {
            this.props.onAnswer()
          }
        }}>Next »</button>
      </span>
    )
  }
}

function storeResult (value, order, type) {
  var currentResult = JSON.parse(sessionStorage.getItem(quizResultDB)) || []
  currentResult[order] = {}
  currentResult[order].type = type
  currentResult[order].value = value
  sessionStorage.setItem(quizResultDB, JSON.stringify(currentResult))
}



// WEBPACK FOOTER //
// ./src/components/Quiz/me-and-my-feelings.js